import React, { useState } from "react";
import { SaveMediaDto } from "src/api/organization/org-types";
import { BaseButton } from "src/components";
import BaseSectionTitle from "src/components/layout/BaseSectionTitle";
import MarkdownViewer from "src/components/MarkdownViewer";
import Link from "src/components/PartnerLink";
import ContractImageUpload from "src/pages/contract/commonComponents/ContractImageUpload";
import { PagePath } from "src/pages/product/details";
import { ApplicationSummary } from "src/pages/product/hooks/useUsageApplication";
import { formatPhoneNumber } from "src/utils";
import UsageApplicationContractorSection from "./UsageApplicationContractorSection";

type Props = {
  applicationSummary: ApplicationSummary;
  applicationValue: string;
  onClose: () => void;
  onEdit?: () => void;
  fileList: SaveMediaDto[];
};

const UsageApplicationDetail = ({ applicationValue, onClose, onEdit, applicationSummary, fileList }: Props) => {
  return (
    <>
      <section className="base-abstract-modal__title flex-center-between border-bottom-gray ">
        <h1>이용신청서</h1>
      </section>

      <section className="base-abstract-modal__contents ">
        <article className="contents-container__wrap-article">
          <div>
            <BaseSectionTitle title="상품정보" className="pb20" noHashLink />
            <div className="flex-center">
              <section className="contents-container__grid">
                <div className="contents-container__grid-index">
                  <p>상품명</p>
                </div>
                <div className="contents-container__grid-contents">
                  <div>
                    <div className="flex-center font14">
                      <p className="mr10">{applicationSummary.productInfo.spaceProductName || "-"}</p>
                      (id:{" "}
                      <Link
                        target="_blank"
                        className="text-underline"
                        to={`${PagePath.product.detail.replace(":id", applicationSummary.productInfo.spaceProductId.toString())}`}
                      >{`${applicationSummary.productInfo.spaceProductId}`}</Link>
                      )
                    </div>
                  </div>
                </div>
              </section>
              <section className="contents-container__grid">
                <div className="contents-container__grid-index">
                  <p>공용공간</p>
                </div>
                <div className="contents-container__grid-contents">
                  <p>{applicationSummary.productInfo.facilityName || "-"}</p>
                </div>
              </section>
            </div>
            <div className="flex-center">
              <section className="contents-container__grid">
                <div className="contents-container__grid-index">
                  <p>신청기간</p>
                </div>
                <div className="contents-container__grid-contents">
                  <p>{applicationSummary.productInfo.useStartEndTime || "-"}</p>
                </div>
              </section>
            </div>
          </div>

          <>
            <UsageApplicationContractorSection applicationSummary={applicationSummary} />
          </>

          <div>
            <BaseSectionTitle title="이용 정보" className="py20" noHashLink />
            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p>상세 내용</p>
              </div>
              <div className="contents-container__grid-contents contents-container__1200">
                <MarkdownViewer value={applicationValue} />
              </div>
            </section>
            <section className="contents-container__grid">
              <div className="contents-container__grid-index">
                <p>첨부파일</p>
              </div>

              <div className="contents-container__grid-contents contents-container__1200">
                <ContractImageUpload type="PROOF" serviceTag={"CONTRACT_DOCUMENT"} isOnlyView={true} fileMaxLength={10} images={fileList} />
              </div>
            </section>
          </div>
        </article>
      </section>
      <section className="base-abstract-modal__btn-wrap ">
        <div className="flex-center">
          <BaseButton title="닫기" className="color-white mr10" onClick={onClose} />
          {onEdit && <BaseButton title="수정" onClick={onEdit} />}
        </div>
      </section>
    </>
  );
};

export default UsageApplicationDetail;
